import { render, staticRenderFns } from "./SocialHappeningsOverview.vue?vue&type=template&id=55710038&scoped=true&"
import script from "./SocialHappeningsOverview.vue?vue&type=script&lang=js&"
export * from "./SocialHappeningsOverview.vue?vue&type=script&lang=js&"
import style0 from "./SocialHappeningsOverview.vue?vue&type=style&index=0&id=55710038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55710038",
  null
  
)

export default component.exports